import TRPC from '@/utils/trpc';
import axios from 'axios';
import _get from 'lodash/get';
import { Platform } from '@shared/const';
import { SERVER_URLS } from '../../../ares-cli/src/commands/build-scripts/const';

function getManifestFromRemote(data) {
  return TRPC.newRequest('ares/QueryPageManifest', {
    ...data,
    Platform: Platform.PlatformH5,
  });
};
async function getManifestFromDevServer() {
  const res = await axios.get(SERVER_URLS[Platform.PlatformH5]);
  const manifest = _get(res, 'data') || {};

  return manifest;
}
// 如果是通过npm（aresDebugger\ares-cli）跑起来
// 则从devServer中获取manifest
// 否则从后台接口获取Manifest
export default process.env.isDebug ?  getManifestFromDevServer : getManifestFromRemote;
